/* Class No Page */
export class NoPage extends HTMLElement {

    connectedCallback() {
        this.render();
    }

    render() {
        this.className = 'no-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo no-page__cuerpo">
                        <div class="no-page__text">
                            <h3 class="body__cuerpo-text-title">Sitio en construcción.</h3>
                            <h3 class="body__cuerpo-text-subtitle">Próximamente más información.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
    }
}

/* Define */
customElements.define("no-page", NoPage)
